import { Button } from "@/components/ui/button"

export function StrategyRecommendation({ recommendation, onExplore }) {
  if (!recommendation?.primary) return null

  return (
    <div className="space-y-4 rounded-lg border border-border bg-card p-4">
      <div>
        <p className="mb-1 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
          System Insight
        </p>
        <p className="text-sm text-foreground">{recommendation.systemInsight}</p>
      </div>

      {recommendation.coachingTensions?.length ? (
        <div className="space-y-2">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
            Options
          </p>
          <div className="flex flex-wrap gap-2">
            {recommendation.coachingTensions.map((tension) => (
              <span
                key={tension}
                className="rounded-md border border-border bg-muted/50 px-2 py-1 text-[11px] font-semibold text-foreground"
              >
                {tension}
              </span>
            ))}
          </div>
        </div>
      ) : null}

      <div className="space-y-4">
        {recommendation.recommendations.map((item) => (
          <div key={item.role} className="border-t border-border pt-4 first:border-t-0 first:pt-0">
            <div className="mb-2 flex flex-wrap items-center gap-2">
              <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
                {item.role}
              </p>
              <span className="rounded-md bg-muted px-2 py-1 text-[10px] font-semibold text-muted-foreground">
                {item.label}
              </span>
            </div>
            <h3 className="text-sm font-bold text-foreground">{item.strategy.title}</h3>
            <p className="mt-1 text-xs text-muted-foreground">{item.strategy.subtitle}</p>
            <p className="mt-2 text-xs text-foreground">{item.rationale}</p>
          </div>
        ))}
      </div>

      <div>
        <Button type="button" variant="secondary" size="sm" onClick={onExplore}>
          Explore Other Strategies
        </Button>
      </div>
    </div>
  )
}
